import { IconProps } from "@/data/types"

export default function BeachIcon({ width=32, height=32, color='#000000', className }: IconProps) {
  return (
    <div className={className}>
      <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"/>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
      <g id="SVGRepo_iconCarrier"> <path d="M6.36407 6.364C9.87878 2.84929 15.5773 2.84929 19.092 6.364L12.728 12.728M6.36407 6.364C2.84935 9.87872 2.84935 15.5772 6.36407 19.0919L12.728 12.728M6.36407 6.364C6.36407 6.364 12.0417 6.38489 15.5564 9.89961M6.36407 6.364C6.36407 6.364 6.38483 12.0417 9.89955 15.5565M12.728 12.728L20 20.0001" stroke={color} strokeWidth="0.8160000000000001" strokeLinecap="round" strokeLinejoin="round"/> </g>
      </svg>
    </div>
  )
}